import { createUseStyles } from 'react-jss';
import { ModalProps } from './';
import { Classes } from 'jss';
import { ActionPalette } from '@tcl-boron-colors/colors';

export const useModalStyles: (
  data?: ModalProps & {
    theme?: Jss.Theme;
  },
) => Classes<'content' | 'root' | 'title' | 'buttons' | 'illustration' | 'titleContentWrapper'> = createUseStyles({
  root: {
    display: ({ centerJustified, illustration }: ModalProps) => (centerJustified || illustration ? '' : 'flex'),
    flexDirection: 'column',
    width: ({ size }: ModalProps) => {
      switch (size) {
        case 'small':
          return '400px';
        case 'large':
          return '700px';
        case 'fullScreen':
          return 'calc(100% - 16px)';
        case 'medium':
        default:
          return '500px';
      }
    },
    height: ({ size }: ModalProps) => (size === 'fullScreen' ? 'calc(100vh - 16px)' : ''),
    top: ({ size }: ModalProps) => (size === 'fullScreen' ? '8px' : ''),
  },
  titleContentWrapper: {
    display: ({ centerJustified, illustration }: ModalProps) => (centerJustified || illustration ? '' : 'flex'),
    flexDirection: 'column',
    height: ({ size }: ModalProps) => (size === 'fullScreen' ? 'calc(100vh - 140px' : ''),
  },
  title: {
    fontSize: '20px',
    fontWeight: '700',
    lineHeight: '24px',
    margin: '0',
    marginBottom: '8px',
    paddingRight: '32px',
    textAlign: ({ centerJustified, illustration }: ModalProps) => (centerJustified || illustration ? 'center' : 'left'),
  },
  content: {
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 'normal',
    textAlign: ({ centerJustified, illustration }: ModalProps) => (centerJustified || illustration ? 'center' : 'left'),
    overflowY: 'scroll',
    scrollbarWidth: 'thin',
    scrollbarColor: `${ActionPalette[400]}`,
    paddingRight: '16px',
    '&::-webkit-scrollbar-thumb': {
      borderRadius: '16px',
      background: `${ActionPalette[400]}`,
      border: '6px solid rgba(0, 0, 0, 0)',
      backgroundClip: 'padding-box',
    },
    '&::-webkit-scrollbar': {
      border: 'none',
      width: '16px',
    },
    '&::-webkit-scrollbar-button': {
      width: '0',
      height: '0',
      display: 'none',
    },
    '&::-webkit-scrollbar-corner': {
      backgroundColor: 'transparent',
    },
  },
  buttons: {
    display: 'flex',
    paddingRight: '32px',
    alignSelf: ({ centerJustified, illustration }: ModalProps) => (centerJustified || illustration ? '' : 'flex-end'),
    marginLeft: ({ centerJustified, illustration }: ModalProps) => (centerJustified || illustration ? '' : 'auto'),
    justifyContent: ({ centerJustified, illustration }: ModalProps) =>
      centerJustified || illustration ? 'center' : 'flex-end',
    marginTop: '24px',
    '& > *:not(last-child)': {
      marginLeft: '12px',
    },
  },
  illustration: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingRight: '32px',
    marginBottom: '24px',
    height: '172px',
  },
});
